var map = {
	"./1p.jpg": 113,
	"./2p.jpg": 114,
	"./3p.jpg": 115,
	"./4p.jpg": 116,
	"./5p.jpg": 117,
	"./6p.jpg": 118,
	"./7p.jpg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;